@if (visTeller()) {
  <span class="teller ikke-print" [class.to-sifret]="teller()>10">{{ teller() }}</span>
}
